import t from 'tcomb';

const RgaBOReportRequest = t.struct({
    additionalDataTypes: t.list(t.String),
    requestDateFrom: t.Number,
    requestDateTo: t.Number,
    responsibleUnit: t.String
}, 'RgaBOReportRequest');

export const getDefaultState = () => new RgaBOReportRequest({
    additionalDataTypes: [],
    requestDateFrom: 0,
    requestDateTo: 0,
    responsibleUnit: ''
});

export default RgaBOReportRequest;



// WEBPACK FOOTER //
// ./src/rga/reports/state/rga-BO-report-request.js